import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kudalogin',
  templateUrl: './kudalogin.component.html',
  styleUrls: ['./kudalogin.component.css']
})
export class KudaloginComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
